module.exports = __webpack_public_path__ + "img/card_payment.ba3644fd.png";